import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from 'layout';
import { userSelector } from 'features/user/selectors';
import { StandardDrawerListOptions } from 'layout/components/drawer/StandardDrawerListOptions';

function RequireTermsOfUseAccepted({ children }: React.PropsWithChildren) {
  const user = useSelector(userSelector);

  if (!user) return <Layout drawerOptions={<StandardDrawerListOptions />} />;

  const { termsOfUseAccepted } = user;

  if (termsOfUseAccepted) {
    return <>{children}</>;
  }

  if (termsOfUseAccepted !== undefined && !termsOfUseAccepted) {
    return <Navigate to="terms-of-use" />;
  }

  return <Layout drawerOptions={<StandardDrawerListOptions />} />;
}

export default RequireTermsOfUseAccepted;
